import { useQuery } from "react-query";
import { fetchBubbleWatchData } from "./api";

export function useBubbleWatch(filters, options={}) {
    return useQuery(["bubbleWatchData", filters], () => fetchBubbleWatchData(filters), {
      staleTime: 60000 * 60, 
      ...options
    })
  }